import styled, { css } from "styled-components";

import { size } from "~/styles/screen";

type Inverted = { inverted?: boolean };

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  flex-wrap: wrap;
  padding: 20px 0px 40px;

  @media screen and (max-width: ${size.small}) {
    align-items: center;
    justify-content: center;
  }
`;

export const Brand = styled.div`
  display: flex;
  width: 32%;
  align-items: center;
  margin-top: 1.875rem;
  margin-left: 5%;
  @media screen and (max-width: ${size.small}) {
    margin-left: 30px;
    align-self: flex-start;
  }
`;

export const LogoContainer = styled.div<Inverted>`
  background-color: transparent;
  width: ${1100 * 0.1}px;
  height: ${235 * 0.1}px;
  ${(props) =>
    props.inverted &&
    css`
      filter: brightness(0) invert(1);
    `}
`;

export const LogoText = styled.text`
  margin-left: 5px;
  font-weight: 700;
  color: black;
  font-family: "Montserrat";
  font-size: 12px;
  line-height: 14.63px;
`;

export const ProductContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 90%;
  margin: 0 auto;
  margin-top: 40px;
  max-width: 1400px;

  @media screen and (max-width: ${size.small}) {
    flex-direction: column;
    padding: 0;
    justify-content: center;
    align-items: center;
  }
`;

export const Anchor = styled.a`
  font-family: "Montserrat";
  color: #72e85f;
  font-weight: 800;
  text-decoration: none;

  &:hover {
    color: #72e85f;
  }
`;
